import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!supabase) return;
    
    // Check if user is already logged in, redirect to admin if so
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate('/admin');
      }
    };
    checkSession();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!supabase) return;
    
    setLoading(true);
    setErrorMsg('');

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        setErrorMsg(error.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.');
      } else {
        navigate('/admin');
      }
    } catch (err) {
      setErrorMsg('Đã xảy ra lỗi kết nối. Vui lòng thử lại sau.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // If Supabase is not configured, show a helpful message instead of crashing
  if (!supabase) {
    return (
      <div className="login-container">
        <div className="login-glass-card">
          <h2 className="login-title" style={{ color: '#fca5a5' }}>Chưa Cấu Hình Supabase</h2>
          <p className="login-subtitle" style={{ textAlign: 'left', lineHeight: '1.6', marginTop: '16px' }}>
            Vui lòng thực hiện các bước sau:
            <br />
            1. Điền thông tin vào file <strong>.env</strong> ở thư mục gốc của dự án.
            <br />
            2. <strong>Bắt buộc: Khởi động lại Server React</strong> (Tắt server chạy lệnh `npm start` cũ bằng <code>Ctrl + C</code> trong terminal, rồi chạy lại <code>npm start</code>) thì React mới nhận cấu hình mới.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-glass-card">
        <h2 className="login-title">Hệ Thống Quản Trị</h2>
        <p className="login-subtitle">Đăng nhập tài khoản Admin của bạn</p>

        {errorMsg && <div className="login-error-alert">{errorMsg}</div>}

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Mật khẩu</label>
            <input
              type="password"
              id="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? <span className="login-spinner"></span> : 'Đăng Nhập'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
